import { useOutletContext } from 'react-router-dom';
import './Certificates.css';

function Certificates() {
  const { userData, onLogout } = useOutletContext();

  return (
    <div className="certificates-page">
      <div className="certificates-content">
        <div className="main-content-wrapper">
          <h1 className="certificates-title">Certificates</h1>
        </div>
      </div>
    </div>
  );
}

export default Certificates;
